var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66942 6.35876L0.138037 1.61356C0.049676 1.52283 0 1.39951 0 1.27089C0 1.14228 0.049676 1.01896 0.138037 0.928232L0.415069 0.642414C0.503009 0.551251 0.622534 0.5 0.747198 0.5C0.871862 0.5 0.991387 0.551251 1.07933 0.642414L5 4.76392L8.92067 0.646664C9.00861 0.555501 9.12814 0.50425 9.2528 0.50425C9.37747 0.50425 9.49699 0.555501 9.58493 0.646664L9.86196 0.932482C9.95032 1.02321 10 1.14653 10 1.27514C10 1.40376 9.95032 1.52708 9.86196 1.61781L5.33058 6.36301C5.14573 6.5473 4.85203 6.54541 4.66942 6.35876Z",
    fill: "#696E7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleDown);
export default __webpack_public_path__ + "static/media/AngleDown.8ff9be01.svg";
export { ForwardRef as ReactComponent };